import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type {
  BorderStyleProps,
  BorderWidthProps,
  HeightProps,
  OverflowProps,
  PositionProps,
  SpaceProps,
  WidthProps,
} from 'styled-system';
import {
  border,
  borderColor,
  borderStyle,
  borderWidth,
  height,
  overflow,
  position,
  space,
  width,
} from 'styled-system';

import type { BorderColorProps } from '../theme/system-types';

const VisuallyHiddenBase = styled.span<
  BorderStyleProps &
    BorderWidthProps &
    BorderColorProps &
    WidthProps &
    HeightProps &
    SpaceProps &
    OverflowProps &
    PositionProps
>`
  ${borderStyle};
  ${borderWidth};
  ${borderColor};
  ${border};
  ${width};
  ${height};
  ${space};
  ${overflow};
  ${position};
  clip: rect(0 0 0 0);
`;

interface VisuallyHiddenProps extends ComponentProps<typeof VisuallyHiddenBase> {
  ref?: React.Ref<HTMLSpanElement>;
}

const VisuallyHidden = ({ ref, ...props }: VisuallyHiddenProps) => (
  <VisuallyHiddenBase
    ref={ref}
    borderStyle="solid"
    borderWidth="small"
    borderColor="sys.neutral.border.weak"
    width="1px"
    height="1px"
    m="-1px"
    p="sp_0"
    overflow="hidden"
    position="absolute"
    {...props}
  />
);

VisuallyHidden.displayName = 'VisuallyHidden';

export default VisuallyHidden;
